import { Component } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { LanguageService } from './core/services/language.service';


@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss']
})
export class AppComponent {
  title = 'New_BackOffice';

  constructor(private languageService: LanguageService, private translate: TranslateService) {
    const browserLang: string = translate.getBrowserLang();
    const lang:string = browserLang.match(/en|es|ar|fr/) ? browserLang : "en";
    this.languageService.setLanguage(browserLang);
  
  }
}
